import React, { Suspense, useRef, useMemo } from "react";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { Sparkles, Float } from "@react-three/drei";
import * as THREE from "three";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_1fb06181-b8a6-4af1-96bd-cebf092d4386/artifacts/i49euikv_vertical_tagline_on_negative_by_zenbusiness.png";

function SpinningLogo() {
  const meshRef = useRef();
  const texture = useLoader(THREE.TextureLoader, LOGO_URL);
  texture.anisotropy = 8;

  const materials = useMemo(() => {
    const edge = new THREE.MeshStandardMaterial({
      color: "#111111",
      metalness: 0.9,
      roughness: 0.25,
    });
    const face = new THREE.MeshStandardMaterial({
      map: texture,
      metalness: 0.3,
      roughness: 0.6,
      emissive: new THREE.Color("#ffffff"),
      emissiveMap: texture,
      emissiveIntensity: 0.25,
    });
    // order: px, nx, py, ny, pz, nz
    return [edge, edge, edge, edge, face, face];
  }, [texture]);

  useFrame((state, delta) => {
    if (meshRef.current) {
      meshRef.current.rotation.y += delta * 0.35;
    }
  });

  return (
    <Float speed={1.4} rotationIntensity={0.15} floatIntensity={0.9}>
      <mesh ref={meshRef} material={materials} position={[0, 0.35, 0]} castShadow>
        <boxGeometry args={[2.3, 2.3, 0.12]} />
      </mesh>
    </Float>
  );
}

function Loader() {
  return null;
}

export default function Scene3D() {
  return (
    <Canvas
      camera={{ position: [0, 0, 5.2], fov: 42 }}
      gl={{ antialias: true, alpha: true }}
      dpr={[1, 2]}
    >
      <ambientLight intensity={0.55} />
      <pointLight position={[0, 0, 4]} intensity={1.2} color="#ffffff" />
      <spotLight
        position={[6, 8, 6]}
        angle={0.35}
        penumbra={1}
        intensity={2.4}
        color="#ffffff"
      />
      <spotLight
        position={[-6, -4, 4]}
        angle={0.4}
        penumbra={1}
        intensity={0.8}
        color="#8f8f8f"
      />
      <Suspense fallback={<Loader />}>
        <SpinningLogo />
      </Suspense>
      <Sparkles
        count={220}
        scale={[14, 10, 8]}
        size={2.2}
        speed={0.35}
        opacity={0.35}
        color="#ffffff"
      />
    </Canvas>
  );
}
